import React from 'react';
import EmailAiWebPreview from './EmailAiWebPreview';
import EmailAiPopup from './EmailAiPopup';
import './EmailPopup.css';

const EmailPopup = ({
  isPopupOpen,
  displayRows,
  selectedRowIndex,
  userId,
  onEmailResult,
  closePopup,
  rowData
}) => {
  // console.log('📧 [EMAIL-POPUP] EmailPopup rendered with props:', {
  //   isPopupOpen,
  //   selectedRowIndex,
  //   hasRowData: !!rowData,
  //   rowDataSelectedTopic: rowData?.selectedTopic
  // });

  if (!isPopupOpen) {
    // console.log('📧 [EMAIL-POPUP] Popup not open, returning null');
    return null;
  }

  // Verwende rowData aus Props, falls vorhanden, sonst fallback auf displayRows
  const selectedRow = rowData || (displayRows && displayRows.length > selectedRowIndex ? displayRows[selectedRowIndex] : null);
  
  if (!selectedRow) {
    console.error('📧 [EMAIL-POPUP] No selectedRow found:', {
      hasRowData: !!rowData,
      hasDisplayRows: !!displayRows,
      displayRowsLength: displayRows?.length,
      selectedRowIndex
    });
    return null;
  }

  // console.log('📧 [EMAIL-POPUP] Using selectedRow:', {
  //   id: selectedRow.id,
  //   business_name: selectedRow.business_name,
  //   selectedTopic: selectedRow.selectedTopic,
  //   lead_reply: selectedRow.lead_reply
  // });

  const hasWebsiteOrSocial = selectedRow?.lead_website || 
                             selectedRow?.lead_instagram || 
                             selectedRow?.lead_tiktok;

  return (
    <div className="popupOverlayWrapper">
      <div className="popupOverlayBackground"></div>
      <div className="popupContentWrapper">
        {/* EmailAiPopup wird jetzt als einzige Komponente gerendert */}
        <EmailAiPopup 
          onClose={closePopup} 
          rowData={selectedRow}
          userId={userId}
          onEmailResult={onEmailResult}
          source="worldDbTable"
          /* Wir geben die WebPreview-Props an EmailAiPopup weiter */
          hasWebPreview={hasWebsiteOrSocial}
          webPreviewProps={{
            website: selectedRow?.lead_website || '',
            instagramUrl: selectedRow?.lead_instagram || '',
            tiktokUrl: selectedRow?.lead_tiktok || '',
            businessName: selectedRow?.business_name || ''
          }}
        />
      </div>
    </div>
  );
};

export default EmailPopup; 